<template>
  <div class="flex items-center">
    <IconCycle class="mr-12" />
    <span class="body-1">
      {{ i18n(translations.label) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCycle } from '@ds/icons/IconCycle'

import translations from './StatusUnderReview.translations'

const i18n = useI18n()
</script>
